var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../../../nunjucks.config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["front/utils/macros.jinja"] = require( "front/utils/macros.jinja" );
dependencies["front/components/AdvertisingBanner/AdvertisingBanner.jinja"] = require( "front/components/AdvertisingBanner/AdvertisingBanner.jinja" );
dependencies["front/utils/sites.jinja"] = require( "front/utils/sites.jinja" );




var shim = require("/var/www/django/adg.org/application/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["assets/app/front/components/AwardsADGContent/AwardsADGContent.jinja"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("front/utils/macros.jinja", false, "assets/app/front/components/AwardsADGContent/AwardsADGContent.jinja", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
context.setVariable("macros", t_1);
output += "\n\n";
env.getTemplate("front/components/AdvertisingBanner/AdvertisingBanner.jinja", false, "assets/app/front/components/AwardsADGContent/AwardsADGContent.jinja", false, function(t_5,t_4) {
if(t_5) { cb(t_5); return; }
t_4.getExported(function(t_6,t_4) {
if(t_6) { cb(t_6); return; }
if(Object.prototype.hasOwnProperty.call(t_4, "AdvertisingBanner")) {
var t_7 = t_4.AdvertisingBanner;
} else {
cb(new Error("cannot import 'AdvertisingBanner'")); return;
}
context.setVariable("AdvertisingBanner", t_7);
if(Object.prototype.hasOwnProperty.call(t_4, "ADVERTISING_ADGAWARDS_1")) {
var t_8 = t_4.ADVERTISING_ADGAWARDS_1;
} else {
cb(new Error("cannot import 'ADVERTISING_ADGAWARDS_1'")); return;
}
context.setVariable("ADVERTISING_ADGAWARDS_1", t_8);
if(Object.prototype.hasOwnProperty.call(t_4, "ADVERTISING_ADGAWARDS_2")) {
var t_9 = t_4.ADVERTISING_ADGAWARDS_2;
} else {
cb(new Error("cannot import 'ADVERTISING_ADGAWARDS_2'")); return;
}
context.setVariable("ADVERTISING_ADGAWARDS_2", t_9);
if(Object.prototype.hasOwnProperty.call(t_4, "ADVERTISING_ADGAWARDS_3")) {
var t_10 = t_4.ADVERTISING_ADGAWARDS_3;
} else {
cb(new Error("cannot import 'ADVERTISING_ADGAWARDS_3'")); return;
}
context.setVariable("ADVERTISING_ADGAWARDS_3", t_10);
output += "\n\n\n";
env.getTemplate("front/utils/sites.jinja", false, "assets/app/front/components/AwardsADGContent/AwardsADGContent.jinja", false, function(t_12,t_11) {
if(t_12) { cb(t_12); return; }
t_11.getExported(function(t_13,t_11) {
if(t_13) { cb(t_13); return; }
if(Object.prototype.hasOwnProperty.call(t_11, "SITE_SUBMISSIONS")) {
var t_14 = t_11.SITE_SUBMISSIONS;
} else {
cb(new Error("cannot import 'SITE_SUBMISSIONS'")); return;
}
context.setVariable("SITE_SUBMISSIONS", t_14);
output += "\n\n\n";
var macro_t_15 = runtime.makeMacro(
["item", "title", "subtitle"], 
["eligible", "release", "eligibleUrl"], 
function (l_item, l_title, l_subtitle, kwargs) {
var callerFrame = frame;
frame = new runtime.Frame();
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
frame.set("item", l_item);
frame.set("title", l_title);
frame.set("subtitle", l_subtitle);
frame.set("eligible", Object.prototype.hasOwnProperty.call(kwargs, "eligible") ? kwargs["eligible"] : runtime.contextOrFrameLookup(context, frame, "None"));frame.set("release", Object.prototype.hasOwnProperty.call(kwargs, "release") ? kwargs["release"] : runtime.contextOrFrameLookup(context, frame, "None"));frame.set("eligibleUrl", Object.prototype.hasOwnProperty.call(kwargs, "eligibleUrl") ? kwargs["eligibleUrl"] : "");var t_16 = "";t_16 += "\n    <li class=\"AwardsADGContent-sheduleListItem\">\n        <div class=\"AwardsADGContent-sheduleListItemDate\">\n            ";
if(l_item && runtime.memberLookup((l_item),"date")) {
t_16 += "<div class=\"AwardsADGContent-sheduleListItemDay\">";
t_16 += runtime.suppressValue(env.getFilter("datetime").call(context, runtime.memberLookup((l_item),"date"),"%d"), env.opts.autoescape);
t_16 += "</div>\n                <div class=\"AwardsADGContent-sheduleListItemMonth\">";
t_16 += runtime.suppressValue(env.getFilter("datetime").call(context, runtime.memberLookup((l_item),"date"),"%b"), env.opts.autoescape);
t_16 += "</div>\n            ";
;
}
else {
t_16 += "<div class=\"AwardsADGContent-sheduleListItemTBD\">TBD</div>\n            ";
;
}
t_16 += "</div>\n        <div class=\"AwardsADGContent-sheduleListItemTitle\">";
t_16 += runtime.suppressValue(l_title, env.opts.autoescape);
t_16 += "</div>\n        <div class=\"AwardsADGContent-sheduleListItemDetails\">";
t_16 += runtime.suppressValue(l_subtitle, env.opts.autoescape);
t_16 += "</div>\n        ";
if(runtime.contextOrFrameLookup(context, frame, "eligible")) {
t_16 += "<div class=\"AwardsADGContent-sheduleListItemEligible\">\n                <a href=\"";
t_16 += runtime.suppressValue((lineno = 22, colno = 29, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "url"), "url", context, [runtime.contextOrFrameLookup(context, frame, "eligibleUrl"),runtime.makeKeywordArgs({"args": [runtime.contextOrFrameLookup(context, frame, "eligible")]})])), env.opts.autoescape);
t_16 += "\">Eligible Projects</a>\n            </div>\n        ";
;
}
if(runtime.contextOrFrameLookup(context, frame, "release")) {
t_16 += "<div class=\"AwardsADGContent-sheduleListItemPressRelease\">\n                <a href=\"";
t_16 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "release"), env.opts.autoescape);
t_16 += "\" target=\"_blank\">Press Release</a>\n            </div>\n        ";
;
}
t_16 += "\n    </li>\n";
;
frame = callerFrame;
return new runtime.SafeString(t_16);
});
context.addExport("ScheduleItem");
context.setVariable("ScheduleItem", macro_t_15);
output += "\n\n\n";
var macro_t_17 = runtime.makeMacro(
[], 
["data", "showPromo", "eligibleUrl"], 
function (kwargs) {
var callerFrame = frame;
frame = new runtime.Frame();
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
frame.set("data", Object.prototype.hasOwnProperty.call(kwargs, "data") ? kwargs["data"] : {});frame.set("showPromo", Object.prototype.hasOwnProperty.call(kwargs, "showPromo") ? kwargs["showPromo"] : true);frame.set("eligibleUrl", Object.prototype.hasOwnProperty.call(kwargs, "eligibleUrl") ? kwargs["eligibleUrl"] : "");var t_18 = "";t_18 += "\n\n<div class=\"AwardsADGContent\">\n\n    ";
if(runtime.contextOrFrameLookup(context, frame, "showPromo")) {
t_18 += "<div class=\"AwardsADGContent-members\">\n        <h2>The annual ADG Awards</h2>\n        ";
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"page")),"winners_year")) {
t_18 += "<a href=\"";
t_18 += runtime.suppressValue((lineno = 42, colno = 21, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "url"), "url", context, ["front:awards_adg_winners-popup",runtime.makeKeywordArgs({"args": [runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"page")),"winners_year")),"typ"),runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"page")),"winners_year")),"year")]})])), env.opts.autoescape);
t_18 += "\" class=\"AwardsADGContent-membersItem\">\n            <div class=\"AwardsADGContent-membersItemImg\" data-animation=\"1\" data-animation-type=\"fade\" data-animation-state=\"initial\" data-animation-delay=\"0\">\n                <img src=\"";
t_18 += runtime.suppressValue((lineno = 44, colno = 33, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "static"), "static", context, ["img/awardsADG/winners.jpg"])), env.opts.autoescape);
t_18 += "\"\n                    srcset=\"";
t_18 += runtime.suppressValue((lineno = 45, colno = 35, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "static"), "static", context, ["img/awardsADG/winners.jpg"])), env.opts.autoescape);
t_18 += " 2x\"\n                    alt=\"\">\n            </div>\n            <h3>";
t_18 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"page")),"winners_year")),"caption"), env.opts.autoescape);
t_18 += "</h3>\n            <div class=\"AwardsADGContent-membersItemText\"><p>Outstanding members in production design within television and film.</p></div>\n            <div class=\"AwardsADGContent-membersItemArrow\">\n                ";
t_18 += runtime.suppressValue((lineno = 51, colno = 38, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "macros")),"svgSprite"), "macros[\"svgSprite\"]", context, ["arrow-list","0 0 140 64",runtime.makeKeywordArgs({"caller": (function (){var macro_t_19 = runtime.makeMacro(
[], 
[], 
function (kwargs) {
var callerFrame = frame;
frame = frame.push(true);
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
var t_20 = "";;
frame = frame.pop();
return new runtime.SafeString(t_20);
});
return macro_t_19;})()})])), env.opts.autoescape);
t_18 += "\n            </div>\n        </a>\n        ";
;
}
t_18 += "<a href=\"";
t_18 += runtime.suppressValue((lineno = 56, colno = 21, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "url"), "url", context, ["front:awards_adg_ceremony-popup"])), env.opts.autoescape);
t_18 += "\" class=\"AwardsADGContent-membersItem\">\n            <div class=\"AwardsADGContent-membersItemImg\" data-animation=\"1\" data-animation-type=\"fade\" data-animation-state=\"initial\" data-animation-delay=\"0\">\n                <img src=\"";
t_18 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"page")),"show_preview_cover")),"w440_url"), env.opts.autoescape);
t_18 += "\"\n                    srcset=\"";
t_18 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"page")),"show_preview_cover")),"w680_url"), env.opts.autoescape);
t_18 += " 2x\"\n                    alt=\"\">\n            </div>\n            <h3>The Ceremony</h3>\n            <div class=\"AwardsADGContent-membersItemText\">";
t_18 += runtime.suppressValue(env.getFilter("safe").call(context, runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"page")),"show_preview_content_rendered")), env.opts.autoescape);
t_18 += "</div>\n            <div class=\"AwardsADGContent-membersItemArrow\">\n                ";
t_18 += runtime.suppressValue((lineno = 65, colno = 38, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "macros")),"svgSprite"), "macros[\"svgSprite\"]", context, ["arrow-list","0 0 140 64",runtime.makeKeywordArgs({"caller": (function (){var macro_t_21 = runtime.makeMacro(
[], 
[], 
function (kwargs) {
var callerFrame = frame;
frame = frame.push(true);
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
var t_22 = "";;
frame = frame.pop();
return new runtime.SafeString(t_22);
});
return macro_t_21;})()})])), env.opts.autoescape);
t_18 += "\n            </div>\n        </a>\n    </div>\n    ";
;
}
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"advertising") && runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"advertising")),runtime.contextOrFrameLookup(context, frame, "ADVERTISING_ADGAWARDS_1")) && env.getFilter("length").call(context, runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"advertising")),runtime.contextOrFrameLookup(context, frame, "ADVERTISING_ADGAWARDS_1")))) {
t_18 += "\n        <div class=\"AwardsADGContent-advertisingBannerWrapper AwardsADGContent-advertisingBannerWrapper--position-1\" data-animation=\"1\" data-animation-type=\"fade\" data-animation-state=\"initial\" data-animation-delay=\"0\">\n            ";
t_18 += runtime.suppressValue((lineno = 73, colno = 30, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "AdvertisingBanner"), "AdvertisingBanner", context, [runtime.makeKeywordArgs({"data": runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"advertising")),runtime.contextOrFrameLookup(context, frame, "ADVERTISING_ADGAWARDS_1")),"size": "wide","position": "ADG AWARDS – POSITION 1"})])), env.opts.autoescape);
t_18 += "\n        </div>\n    ";
;
}
t_18 += "\n\n    <div class=\"AwardsADGContent-shedule\">\n        <h2>Submissions</h2>\n\n        ";
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"page")),"overview_rendered") && runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"page")),"pdf")) {
t_18 += "\n            <div class=\"AwardsADGContent-sheduleRules\">\n                <div class=\"AwardsADGContent-sheduleRulesText\">";
t_18 += runtime.suppressValue(env.getFilter("safe").call(context, runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"page")),"overview_rendered")), env.opts.autoescape);
t_18 += "</div>\n                ";
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"page")),"pdf")) {
t_18 += "<a href=\"";
t_18 += runtime.suppressValue((lineno = 84, colno = 47, runtime.callWrap(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"page")),"pdf")),"url"), "data[\"page\"][\"pdf\"][\"url\"]", context, [])), env.opts.autoescape);
t_18 += "\" class=\"AwardsADGContent-sheduleRulesButton\">Rules & Specifications</a>\n                ";
;
}
t_18 += "</div>\n        ";
;
}
t_18 += "\n\n        <ul class=\"AwardsADGContent-sheduleList\">\n            ";
t_18 += runtime.suppressValue((lineno = 90, colno = 25, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "ScheduleItem"), "ScheduleItem", context, [runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"schedule")),"submissions")),"so"),"SUBMISSIONS OPEN","FOR TELEVISION & FEATURE FILM",runtime.makeKeywordArgs({"eligibleUrl": runtime.contextOrFrameLookup(context, frame, "eligibleUrl")})])), env.opts.autoescape);
t_18 += "\n            ";
t_18 += runtime.suppressValue((lineno = 91, colno = 25, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "ScheduleItem"), "ScheduleItem", context, [runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"schedule")),"submissions")),"tv_sc"),"TELEVISION SUBMISSIONS CLOSE","FEATURE FILM SUBMISSIONS REMAIN OPEN",runtime.makeKeywordArgs({"eligibleUrl": runtime.contextOrFrameLookup(context, frame, "eligibleUrl")})])), env.opts.autoescape);
t_18 += "\n            ";
t_18 += runtime.suppressValue((lineno = 92, colno = 25, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "ScheduleItem"), "ScheduleItem", context, [runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"schedule")),"submissions")),"tv_sr"),"TELEVISION SUBMISSIONS REVIEW","BY THE AWARDS COMMITTEE",runtime.makeKeywordArgs({"eligibleUrl": runtime.contextOrFrameLookup(context, frame, "eligibleUrl")})])), env.opts.autoescape);
t_18 += "\n            ";
t_18 += runtime.suppressValue((lineno = 93, colno = 25, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "ScheduleItem"), "ScheduleItem", context, [runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"schedule")),"submissions")),"tv_ep"),"ELIGIBLE TELEVISION PROJECTS POSTED","UPLOADED ASSETS & PRESENTATIONS VISIBLE (ROLLING)",runtime.makeKeywordArgs({"eligible": runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"eligible")),"tv"),"eligibleUrl": runtime.contextOrFrameLookup(context, frame, "eligibleUrl")})])), env.opts.autoescape);
t_18 += "\n            ";
t_18 += runtime.suppressValue((lineno = 94, colno = 25, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "ScheduleItem"), "ScheduleItem", context, [runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"schedule")),"submissions")),"film_ep"),"ELIGIBLE FEATURE FILM PROJECTS POSTED","UPLOADED ASSETS & PRESENTATIONS VISIBLE (ROLLING)",runtime.makeKeywordArgs({"eligible": runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"eligible")),"film"),"eligibleUrl": runtime.contextOrFrameLookup(context, frame, "eligibleUrl")})])), env.opts.autoescape);
t_18 += "\n            ";
t_18 += runtime.suppressValue((lineno = 95, colno = 25, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "ScheduleItem"), "ScheduleItem", context, [runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"schedule")),"submissions")),"uc"),"ASSETS & PRESENTATION UPLOADS CLOSE","FEATURE FILM SUBMISSIONS CLOSE",runtime.makeKeywordArgs({"eligibleUrl": runtime.contextOrFrameLookup(context, frame, "eligibleUrl")})])), env.opts.autoescape);
t_18 += "\n        </ul>\n\n        ";
if((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"submitButton"))) {
t_18 += "\n            <a class=\"AwardsADGContent-sheduleListSubmit\" href=\"";
t_18 += runtime.suppressValue((lineno = 99, colno = 75, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "domain_url"), "domain_url", context, [runtime.contextOrFrameLookup(context, frame, "SITE_SUBMISSIONS"),"submissions"])), env.opts.autoescape);
t_18 += "\">Submit a Project</a>\n        ";
;
}
t_18 += "\n    </div>\n\n\n    ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"advertising") && runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"advertising")),runtime.contextOrFrameLookup(context, frame, "ADVERTISING_ADGAWARDS_2")) && env.getFilter("length").call(context, runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"advertising")),runtime.contextOrFrameLookup(context, frame, "ADVERTISING_ADGAWARDS_2")))) {
t_18 += "\n        <div class=\"AwardsADGContent-advertisingBannerWrapper AwardsADGContent-advertisingBannerWrapper--position-2\" data-animation=\"1\" data-animation-type=\"fade\" data-animation-state=\"initial\" data-animation-delay=\"0\">\n            ";
t_18 += runtime.suppressValue((lineno = 106, colno = 30, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "AdvertisingBanner"), "AdvertisingBanner", context, [runtime.makeKeywordArgs({"data": runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"advertising")),runtime.contextOrFrameLookup(context, frame, "ADVERTISING_ADGAWARDS_2")),"size": "wide","position": "ADG AWARDS – POSITION 2"})])), env.opts.autoescape);
t_18 += "\n        </div>\n    ";
;
}
t_18 += "\n\n    <div class=\"AwardsADGContent-shedule\">\n        <h2>Voting</h2>\n        <ul class=\"AwardsADGContent-sheduleList\">\n            ";
t_18 += runtime.suppressValue((lineno = 113, colno = 25, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "ScheduleItem"), "ScheduleItem", context, [runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"schedule")),"voting")),"nvb"),"NOMINATION VOTING BEGINS","FOR TELEVISION & FEATURE FILM PROJECTS (ART DIRECTORS ONLY)",runtime.makeKeywordArgs({"eligibleUrl": runtime.contextOrFrameLookup(context, frame, "eligibleUrl")})])), env.opts.autoescape);
t_18 += "\n            ";
t_18 += runtime.suppressValue((lineno = 114, colno = 25, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "ScheduleItem"), "ScheduleItem", context, [runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"schedule")),"voting")),"nve"),"NOMINATION VOTING ENDS","FOR TELEVISION & FEATURE FILM PROJECTS (ART DIRECTORS ONLY)",runtime.makeKeywordArgs({"eligibleUrl": runtime.contextOrFrameLookup(context, frame, "eligibleUrl")})])), env.opts.autoescape);
t_18 += "\n            ";
t_18 += runtime.suppressValue((lineno = 115, colno = 25, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "ScheduleItem"), "ScheduleItem", context, [runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"schedule")),"voting")),"na"),"NOMINATIONS ANNOUNCED","BY THE AWARDS COMMITTEE",runtime.makeKeywordArgs({"release": runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"page")),"nominations_release_visible") && runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"page")),"nominations_release") && (lineno = 115, colno = 220, runtime.callWrap(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"page")),"nominations_release")),"url"), "data[\"page\"][\"nominations_release\"][\"url\"]", context, [])),"eligibleUrl": runtime.contextOrFrameLookup(context, frame, "eligibleUrl")})])), env.opts.autoescape);
t_18 += "\n            ";
t_18 += runtime.suppressValue((lineno = 116, colno = 25, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "ScheduleItem"), "ScheduleItem", context, [runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"schedule")),"voting")),"fvb"),"FINAL VOTING BEGINS","FOR FINAL BALLOTS (ALL CRAFTS)",runtime.makeKeywordArgs({"eligibleUrl": runtime.contextOrFrameLookup(context, frame, "eligibleUrl")})])), env.opts.autoescape);
t_18 += "\n            ";
t_18 += runtime.suppressValue((lineno = 117, colno = 25, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "ScheduleItem"), "ScheduleItem", context, [runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"schedule")),"voting")),"fve"),"FINAL VOTING ENDS","FOR FINAL BALLOTS (ALL CRAFTS)",runtime.makeKeywordArgs({"eligibleUrl": runtime.contextOrFrameLookup(context, frame, "eligibleUrl")})])), env.opts.autoescape);
t_18 += "\n        </ul>\n    </div>\n\n\n    <div class=\"AwardsADGContent-shedule\">\n        <h2>Award ceremony</h2>\n        <ul class=\"AwardsADGContent-sheduleList\">\n            ";
t_18 += runtime.suppressValue((lineno = 125, colno = 25, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "ScheduleItem"), "ScheduleItem", context, [runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"schedule")),"gala")),"aag"),"THE ANNUAL AWARDS GALA\nWINNERS ANNOUNCED","INTERCONTINENTAL LOS ANGELES DOWNTOWN",runtime.makeKeywordArgs({"release": runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"page")),"show_release_visible") && runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"page")),"show_release") && (lineno = 125, colno = 232, runtime.callWrap(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"page")),"show_release")),"url"), "data[\"page\"][\"show_release\"][\"url\"]", context, [])),"eligibleUrl": runtime.contextOrFrameLookup(context, frame, "eligibleUrl")})])), env.opts.autoescape);
t_18 += "\n        </ul>\n    </div>\n\n\n    ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"categories") && env.getFilter("length").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"categories"))) {
t_18 += "\n        <div class=\"AwardsADGContent-rules\">\n            <h2>AWARD CATEGORIES</h2>\n\n            ";
frame = frame.push();
var t_25 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"categories");
if(t_25) {t_25 = runtime.fromIterator(t_25);
var t_24 = t_25.length;
for(var t_23=0; t_23 < t_25.length; t_23++) {
var t_26 = t_25[t_23];
frame.set("category", t_26);
frame.set("loop.index", t_23 + 1);
frame.set("loop.index0", t_23);
frame.set("loop.revindex", t_24 - t_23);
frame.set("loop.revindex0", t_24 - t_23 - 1);
frame.set("loop.first", t_23 === 0);
frame.set("loop.last", t_23 === t_24 - 1);
frame.set("loop.length", t_24);
t_18 += "<div class=\"AwardsADGContent-rulesCategories\">\n                <h3>";
t_18 += runtime.suppressValue(runtime.memberLookup((t_26),"title"), env.opts.autoescape);
t_18 += "</h3>\n                <ul class=\"AwardsADGContent-rulesCategoriesList\">\n                ";
frame = frame.push();
var t_29 = runtime.memberLookup((t_26),"list");
if(t_29) {t_29 = runtime.fromIterator(t_29);
var t_28 = t_29.length;
for(var t_27=0; t_27 < t_29.length; t_27++) {
var t_30 = t_29[t_27];
frame.set("item", t_30);
frame.set("loop.index", t_27 + 1);
frame.set("loop.index0", t_27);
frame.set("loop.revindex", t_28 - t_27);
frame.set("loop.revindex0", t_28 - t_27 - 1);
frame.set("loop.first", t_27 === 0);
frame.set("loop.last", t_27 === t_28 - 1);
frame.set("loop.length", t_28);
t_18 += "<li class=\"AwardsADGContent-rulesCategoriesListItem\">\n                        <div class=\"AwardsADGContent-rulesCategoriesListItemCategory\">";
t_18 += runtime.suppressValue(runtime.memberLookup((t_30),"category"), env.opts.autoescape);
t_18 += "</div>\n                        <div class=\"AwardsADGContent-rulesCategoriesListItemTitle\">\n                            <div class=\"AwardsADGContent-rulesCategoriesListItemTable\">\n                                <div class=\"AwardsADGContent-rulesCategoriesListItemCell\">";
t_18 += runtime.suppressValue(runtime.memberLookup((t_30),"title"), env.opts.autoescape);
t_18 += "</div>\n                            </div>\n                        </div>\n                        ";
if(runtime.memberLookup((t_30),"new")) {
t_18 += "\n                            <div class=\"AwardsADGContent-rulesCategoriesListItemLabel\">new</div>\n                        ";
;
}
t_18 += "\n                    </li>\n                ";
;
}
}
frame = frame.pop();
t_18 += "\n                </ul>\n            </div>\n            ";
;
}
}
frame = frame.pop();
t_18 += "</div>\n    ";
;
}
t_18 += "\n\n\n    ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"crafts") && env.getFilter("length").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"crafts"))) {
t_18 += "\n        <div class=\"AwardsADGContent-crafts\">\n            <h2>Recognized crafts</h2>\n\n            <div class=\"AwardsADGContent-craftsWrapper ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"advertising") && runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"advertising")),runtime.contextOrFrameLookup(context, frame, "ADVERTISING_ADGAWARDS_3")) && env.getFilter("length").call(context, runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"advertising")),runtime.contextOrFrameLookup(context, frame, "ADVERTISING_ADGAWARDS_3")))) {
t_18 += "AwardsADGContent-craftsWrapper--hasAdvertising";
;
}
t_18 += "\">\n                ";
frame = frame.push();
var t_33 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"crafts");
if(t_33) {t_33 = runtime.fromIterator(t_33);
var t_32 = t_33.length;
for(var t_31=0; t_31 < t_33.length; t_31++) {
var t_34 = t_33[t_31];
frame.set("craft", t_34);
frame.set("loop.index", t_31 + 1);
frame.set("loop.index0", t_31);
frame.set("loop.revindex", t_32 - t_31);
frame.set("loop.revindex0", t_32 - t_31 - 1);
frame.set("loop.first", t_31 === 0);
frame.set("loop.last", t_31 === t_32 - 1);
frame.set("loop.length", t_32);
t_18 += "<div class=\"AwardsADGContent-craftsColumn\">\n                        <h3>";
t_18 += runtime.suppressValue((lineno = 165, colno = 50, runtime.callWrap(runtime.memberLookup((t_34),"get_kind_display"), "craft[\"get_kind_display\"]", context, [])), env.opts.autoescape);
t_18 += " Craft</h3>\n                        <div>";
t_18 += runtime.suppressValue(env.getFilter("safe").call(context, runtime.memberLookup((t_34),"content_rendered")), env.opts.autoescape);
t_18 += "</div>\n                    </div>\n                    ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index") % 3 == 0) {
t_18 += "<div class=\"AwardsADGContent-craftsColumnSeparator\"></div>\n                    ";
;
}
;
}
}
frame = frame.pop();
t_18 += "</div>\n\n            ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"advertising") && runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"advertising")),runtime.contextOrFrameLookup(context, frame, "ADVERTISING_ADGAWARDS_3")) && env.getFilter("length").call(context, runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"advertising")),runtime.contextOrFrameLookup(context, frame, "ADVERTISING_ADGAWARDS_3")))) {
t_18 += "\n                <div class=\"AwardsADGContent-advertisingBannerWrapper AwardsADGContent-advertisingBannerWrapper--position-3\" data-animation=\"1\" data-animation-type=\"fade\" data-animation-state=\"initial\" data-animation-delay=\"0\">\n                    ";
t_18 += runtime.suppressValue((lineno = 176, colno = 38, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "AdvertisingBanner"), "AdvertisingBanner", context, [runtime.makeKeywordArgs({"data": runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"advertising")),runtime.contextOrFrameLookup(context, frame, "ADVERTISING_ADGAWARDS_3")),"size": "square","position": "ADG AWARDS – POSITION 3"})])), env.opts.autoescape);
t_18 += "\n                </div>\n            ";
;
}
t_18 += "\n        </div>\n    ";
;
}
t_18 += "\n\n    ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"downloads") && env.getFilter("length").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"downloads"))) {
t_18 += "\n        <div class=\"AwardsADGContent-downloads\">\n            <h2>Downloads</h2>\n            <ul class=\"AwardsADGContent-downloadsList\">\n                ";
frame = frame.push();
var t_37 = (runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "item")),"release")?runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"downloads"):"");
if(t_37) {t_37 = runtime.fromIterator(t_37);
var t_36 = t_37.length;
for(var t_35=0; t_35 < t_37.length; t_35++) {
var t_38 = t_37[t_35];
frame.set("item", t_38);
frame.set("loop.index", t_35 + 1);
frame.set("loop.index0", t_35);
frame.set("loop.revindex", t_36 - t_35);
frame.set("loop.revindex0", t_36 - t_35 - 1);
frame.set("loop.first", t_35 === 0);
frame.set("loop.last", t_35 === t_36 - 1);
frame.set("loop.length", t_36);
t_18 += "<li class=\"AwardsADGContent-downloadsListItem\">\n                        <a class=\"AwardsADGContent-downloadsListItemLink\" href=\"";
t_18 += runtime.suppressValue((lineno = 188, colno = 96, runtime.callWrap(runtime.memberLookup((runtime.memberLookup((t_38),"release")),"url"), "item[\"release\"][\"url\"]", context, [])), env.opts.autoescape);
t_18 += "\">\n                        <div class=\"AwardsADGContent-downloadsListItemTitle\">";
t_18 += runtime.suppressValue(runtime.memberLookup((t_38),"title"), env.opts.autoescape);
t_18 += "</div>\n                        <div class=\"AwardsADGContent-downloadsListItemArrow\">\n                            ";
t_18 += runtime.suppressValue((lineno = 191, colno = 50, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "macros")),"svgSprite"), "macros[\"svgSprite\"]", context, ["arrow-list","0 0 140 64",runtime.makeKeywordArgs({"caller": (function (){var macro_t_39 = runtime.makeMacro(
[], 
[], 
function (kwargs) {
var callerFrame = frame;
frame = frame.push(true);
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
var t_40 = "";;
frame = frame.pop();
return new runtime.SafeString(t_40);
});
return macro_t_39;})()})])), env.opts.autoescape);
t_18 += "\n                        </div>\n                        </a>\n                    </li>\n                ";
;
}
}
frame = frame.pop();
t_18 += "\n            </ul>\n        </div>\n    ";
;
}
t_18 += "\n\n    ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"sponsors") && env.getFilter("length").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"sponsors"))) {
t_18 += "\n        <div class=\"AwardsADGContent-sponsors\">\n            <h2>Media Sponsors</h2>\n            <div class=\"AwardsADGContent-sponsorsColumns\">\n                <div class=\"AwardsADGContent-sponsorsLeftColumn\">";
t_18 += runtime.suppressValue(env.getFilter("safe").call(context, runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"page")),"media_rendered")), env.opts.autoescape);
t_18 += "</div>\n                <div class=\"AwardsADGContent-sponsorsRightColumn\">\n                    ";
frame = frame.push();
var t_43 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"sponsors");
if(t_43) {t_43 = runtime.fromIterator(t_43);
var t_42 = t_43.length;
for(var t_41=0; t_41 < t_43.length; t_41++) {
var t_44 = t_43[t_41];
frame.set("item", t_44);
frame.set("loop.index", t_41 + 1);
frame.set("loop.index0", t_41);
frame.set("loop.revindex", t_42 - t_41);
frame.set("loop.revindex0", t_42 - t_41 - 1);
frame.set("loop.first", t_41 === 0);
frame.set("loop.last", t_41 === t_42 - 1);
frame.set("loop.length", t_42);
t_18 += "<div class=\"AwardsADGContent-sponsorsRightColumnImage\" data-animation=\"1\" data-animation-type=\"fade\" data-animation-state=\"initial\" data-animation-delay=\"";
t_18 += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index0") * 100, env.opts.autoescape);
t_18 += "\">\n                            <img src=\"";
t_18 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((t_44),"img")),"w500_url"), env.opts.autoescape);
t_18 += "\" alt=\"\">\n                        </div>\n                    ";
;
}
}
frame = frame.pop();
t_18 += "\n                </div>\n            </div>\n        </div>\n    ";
;
}
t_18 += "\n</div>\n";
;
frame = callerFrame;
return new runtime.SafeString(t_18);
});
context.addExport("AwardsADGContent");
context.setVariable("AwardsADGContent", macro_t_17);
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["assets/app/front/components/AwardsADGContent/AwardsADGContent.jinja"] , dependencies)


//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/AwardsADGContent/AwardsADGContent.jinja
// module id = 475
// module chunks = 0